/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Clients_Validation_Dob_Invalid_DayInputs */

const en_clients_validation_dob_invalid_day = /** @type {(inputs: Clients_Validation_Dob_Invalid_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Day must be valid for this month (up to ${i?.days}).`)
};

const pt_br2_clients_validation_dob_invalid_day = /** @type {(inputs: Clients_Validation_Dob_Invalid_DayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O dia deve ser válido para este mês (até ${i?.days}).`)
};

/**
* | output |
* | --- |
* | "Day must be valid for this month (up to {days})." |
*
* @param {Clients_Validation_Dob_Invalid_DayInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_dob_invalid_day = /** @type {((inputs: Clients_Validation_Dob_Invalid_DayInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Dob_Invalid_DayInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_dob_invalid_day(inputs)
	return pt_br2_clients_validation_dob_invalid_day(inputs)
});